export default function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/es/internal/_isObject.js
// module id = 74
// module chunks = 23